import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";

export default function AuthCallback() {
  const { instance } = useMsal();

  useEffect(() => {
    instance.handleRedirectPromise().then(() => {
      window.location.href = "/";
    });
  }, [instance]);

  return <div>Processing authentication...</div>;
}